export const theme = {
  colors: {
    background: '#ccd1d3',
    text: '#1A3948',
    highlighted_text: '#F8F7F6',
    orange: '#FF5400',
  },
  ease: {
    in: 'cubic-bezier(.55,.06,.68,.19)',
    out: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
    inOut: 'cubic-bezier(.46,.03,.52,.96)',
  },
};
